import React from 'react'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

const Layout = styled('div')(({ theme }) => ({
  maxWidth: '1400px',
  width: '100%',
  margin: '0 auto',
  flex: 1,
  padding: theme.spacing(3)
}))

const ErrorView: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flex: 1, backgroundColor: 'error.main' }}>
      <Layout>
        <Typography
          sx={{ fontWeight: 'fontWeightLight', lineHeight: 1, color: 'common.white' }}
          variant="h3"
          component="h1"
        >
          {t('500-system-error')}
        </Typography>
      </Layout>
    </Box>
  )
}

export default ErrorView
